import { DefaultService } from '@/services/DefaultService';

export default class AuditoriaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    findById(id) {
        return this._http.get(`${this._env}/system/audit/${id}.json`, this._headers)
                    .then(res => res.body, this.handleError);
    }

    findAll(filtros, page, limit) {
        return this._http.post(`${this._env}/system/audit.json?page=${page}&limit=${limit}`, filtros, this._headers)
                    .then( res => res.body, this.handleError);
    }

    findAuditLoginById(id) {
        return this._http.get(`${this._env}/system/auditlogin/${id}.json`, this._headers)
                    .then(res => res.body, this.handleError);
    }

    findAllAuditLogin(filtros) {
        let page = filtros.pageNumber;
        let limit = filtros.limit;
        return this._http.post(`${this._env}/system/auditlogin.json?page=${page}&limit=${limit}`, filtros, this._headers)
                    .then( res => res.body, this.handleError);
    }

    findAllOrigens() {
        return this._http.get(`${this._env}/system/audit/origens.json`, this._headers)
                    .then( res => res.body,  this.handleError);
    }

    findAllOperacao() {
        return this._http.get(`${this._env}/system/audit/operacao.json`, this._headers)
                    .then( res => res.body,  this.handleError);
    }

}